import * as React from 'react';

function SvgAzMenu(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 20 12" {...props}>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M6.042 0l2.847 12H6.337l-.66-2.76h-2.83L2.222 12H0L3.003 0h3.039zM19.95 0v2.04l-4.799 7.611H20V12h-8.148V9.994L16.65 2.35h-4.766V0h8.065zM4.236 3.154L3.16 7.817h2.205L4.236 3.154z"
			/>
		</svg>
	);
}

export default SvgAzMenu;
